export default __webpack_public_path__ + "static/media/vf-green.23a255ca.svg";